(() => {
  'use strict';

  const isHomepage = () => window.location.pathname === '/';

  const hideAnnouncementBar = () => {
    if (!isHomepage()) return;
    
    document.documentElement.classList.add('convert-hide-announcement');
    
    const announcementBars = document.querySelectorAll('.announcement-section');
    
    announcementBars.forEach(bar => {
      if (!bar.dataset.originalDisplay) {
        bar.dataset.originalDisplay = bar.style.display || '';
      }
      bar.style.display = 'none';
    });
  };

  const showAnnouncementBar = () => {
    document.documentElement.classList.remove('convert-hide-announcement');
    
    const announcementBars = document.querySelectorAll('.announcement-section');
    
    announcementBars.forEach(bar => {
      if (bar.dataset.originalDisplay !== undefined) {
        bar.style.display = bar.dataset.originalDisplay || '';
        delete bar.dataset.originalDisplay;
      }
    });
  };

  window.convertAnnouncementBarTest = {
    control() {
      showAnnouncementBar();
    },
    
    variant() {
      hideAnnouncementBar();
    },
    
    reset() {
      this.control();
    }
  };

  document.addEventListener('page:load', () => window.convertAnnouncementBarTest.control?.());
})();
